import z from "zod";
import { defineObject } from "sanity-typed-queries";
var schema = defineObject("simpleDatalistSectionRow", {
    title: {
        title: "Title",
        type: "string",
        validation: function(Rule) {
            return Rule.required();
        }
    },
    values: {
        title: "Value(s)",
        type: "array",
        of: [
            {
                type: "string"
            }
        ],
        validation: function(Rule) {
            return Rule.required().min(1);
        }
    }
}, []);
var validator = z.object({
    _type: z.literal("simpleDatalistSectionRow"),
    title: z.string().optional(),
    values: z.array(z.string()).optional()
});
schema.simpleDatalistSectionRow;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=simpleDatalistSectionRow.js.map